import { InputLabel, styled } from '@mui/material';

import CommonEditor from '../../../components/Common/Editor';

import breakpoints from '../../../constants/breakpoints';

export const Editor = styled(CommonEditor)(({ theme, isInvalid = false }) => ({
  '& .tiptap.ProseMirror': {
    backgroundColor: 'transparent',
    maxHeight: 'var(--preference-compose-editor-max-height-desktop)',
    minHeight: 'var(--preference-compose-editor-min-height)',
    padding: 'var(--spacing-medium)',
    [theme.breakpoints.down(breakpoints.tabletS)]: {
      maxHeight: 'var(--preference-compose-editor-max-height-mobile)',
    },
  },
  '& > ul': {
    marginInline: 'var(--spacing-tiny)',
  },
  '&:focus-within': {
    borderColor: theme.palette[isInvalid ? 'error' : 'primary'].main,
    borderWidth: '2px',
  },
  '&:hover': {
    borderColor: isInvalid
      ? theme.palette.error.main
      : theme.palette.primary.dark,
  },
  borderColor: theme.palette[isInvalid ? 'error' : 'neutral'].main,
  borderRadius: 'var(--border-radius-tiny)',
  paddingTop: 'var(--spacing-tiny)',
}));

export const StyledLabel = styled(InputLabel)(() => ({
  backgroundColor: 'var(--color-background-compose)',
  marginLeft: 'calc(-1 * var(--spacing-tiny))',
  paddingInline: 'var(--spacing-small)',
}));
